<template>
  <div class="card">
    <div
      v-if="legend"
      class="card-header p-1 mb-0 text-center bg-light"
      :title="legend.tooltip"
    >
      <div class="font-weight-bold">
        {{ legend.title }}
      </div>
      <div class="small" v-if="!this.makeSmall">
        {{ legend.subtitle }}
        <i
          class="fa fa-question-circle ml-2 user-select-none"
          style="cursor: pointer"
        ></i>
      </div>
    </div>
    <div class="card-body px-2 py-4 text-center" v-if="resultsIsLoading">
      <b-spinner small class="mr-1"></b-spinner>
      <span class="small">Loading...</span>
    </div>
    <div class="card-body p-0 bg-secondary pt-1 pl-1" v-if="!showSmallRanges">
      <div
        v-if="legend && legend.ranges && legend.ranges.length > 0"
        v-for="(range, index) in legend.ranges"
        :key="index"
        class="text-center badge-discrete-legend mb-1 mr-1 d-flex justify-content-start"
        :style="{
          color: range.color,
          'background-color': range.backgroundColor,
          'border-color': range.color,
        }"
        :title="
          range.locationCount
            ? `${range.locationCount} locations reported ${range.text}`
            : `No locations reported ${range.text}`
        "
      >
        <i
          class="mr-2 flex-none"
          :class="range.symbol.type"
          v-if="range.symbol.type && markerType === 'xl'"
        ></i
        ><span
          class="mr-2 flex-none"
          v-if="
            range.symbol.text &&
            legend.useFullValues === false &&
            markerType === 'xl'
          "
          >({{ range.symbol.text }})</span
        ><span>{{ range.text }}</span>
      </div>
      <div
        v-if="displayNoData"
        class="badge-discrete-legend mb-1 mr-1 d-flex justify-content-start"
        :style="{
          color: legend.rangeNoData.color,
          'background-color': legend.rangeNoData.backgroundColor,
          'border-color': legend.rangeNoData.color,
        }"
        :title="`Locations with no data`"
      >
        <i
          class="mr-2 flex-none"
          :class="legend.rangeNoData.symbol.type"
          v-if="legend.rangeNoData.symbol.type && markerType === 'xl'"
        ></i
        ><span
          class="mr-2 flex-none"
          v-if="
            legend.rangeNoData.symbol.text &&
            legend.useFullValues === false &&
            markerType === 'xl'
          "
          >({{ legend.rangeNoData.symbol.text }})</span
        ><span>{{ legend.rangeNoData.text }}</span>
      </div>
      <div
        class="project-home badge-discrete-legend mb-1 mr-1"
        :style="{
          color: '#000000',
          'background-color': '#ffffff',
          'border-color': '#c2c2c2',
        }"
      >
        <i class="fa fa-home pr-1"></i>Project Home
      </div>
    </div>
    <div
      class="card-body p-0 bg-secondary pt-1 pl-1 d-flex flex-wrap"
      v-if="showSmallRanges"
    >
      <div
        v-if="legend && legend.ranges && legend.ranges.length > 0"
        v-for="(range, index) in legend.ranges"
        :key="index"
        class="text-center badge-discrete-legend mb-1 mr-1 d-inline-flex justify-content-start"
        :style="{
          color: range.color,
          'background-color': range.backgroundColor,
          'border-color': range.color,
        }"
        :title="
          range.locationCount
            ? `${range.locationCount} locations reported ${range.text}`
            : `No locations reported ${range.text}`
        "
      >
        <i
          class="mr-2 flex-none"
          :class="range.symbol.type"
          v-if="range.symbol.type && markerType === 'xl'"
        ></i
        ><span
          class="mr-2 flex-none"
          v-if="
            range.symbol.text &&
            legend.useFullValues === false &&
            markerType === 'xl'
          "
          >({{ range.symbol.text }})</span
        ><span class="">{{ range.text }}</span>
      </div>
      <div
        v-if="displayNoData"
        class="badge-discrete-legend mb-1 mr-1 d-inline-flex justify-content-start"
        :style="{
          color: legend.rangeNoData.color,
          'background-color': legend.rangeNoData.backgroundColor,
          'border-color': legend.rangeNoData.color,
        }"
        :title="`Locations with no data`"
      >
        <i
          class="mr-2 flex-none"
          :class="legend.rangeNoData.symbol.type"
          v-if="legend.rangeNoData.symbol.type && markerType === 'xl'"
        ></i
        ><span
          class="mr-2 flex-none"
          v-if="
            legend.rangeNoData.symbol.text &&
            legend.useFullValues === false &&
            markerType === 'xl'
          "
          >({{ legend.rangeNoData.symbol.text }})</span
        ><span>{{ legend.rangeNoData.text }}</span>
      </div>
      <div
        class="project-home badge-discrete-legend mb-1 mr-1"
        :style="{
          color: '#000000',
          'background-color': '#ffffff',
          'border-color': '#c2c2c2',
        }"
      >
        <i class="fa fa-home pr-1"></i>Home
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "DiscreteDataLegend",
  props: {
    makeSmall: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      resultsIsLoading: (state) => state.project.map.resultsIsLoading,
      displayNoData: (state) => state.project.map.displayNoData,
    }),
    ...mapGetters({
      legend: "project/map/legend",
      markerType: "project/map/markerType",
    }),
    showSmallRanges() {
      //
      if (this.makeSmall) {
        return true;
      }

      const noData = this.displayNoData ? 1 : 0;
      const home = 1;
      const totalRanges =
        this.legend && this.legend.ranges
          ? this.legend.ranges.length + noData + home
          : 0;
      if (totalRanges >= 7) {
        return true;
      }
      return false;
    },
  },

  methods: {},
};
</script>

<style scoped>
.badge-discrete-legend {
  border: 2px solid;
  padding: 0.25em 0.4em;
  line-height: 1;
  text-align: center;
  border-radius: 0.25rem;
}
</style>
